import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { diffKeys } from "./query-keys";

/**
 * One SKU's recent shelf-count reports (spec D6). Disabled until a row is
 * clicked — the drawer is closed most of the time, and nobody needs 4,338
 * histories prefetched.
 */
export function useDiffHistory(sku: string | null) {
  return useQuery({
    queryKey: diffKeys.history(sku ?? ""),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/reports/inventory-diff/{sku}/history", {
        params: { path: { sku: sku! } },
      });
      if (error) throw error;
      return data;
    },
    enabled: sku !== null,
    staleTime: 30_000,
  });
}
